import { HandleSendMessageProps, Message } from '../../types/chat';
import { textChat } from '../../fetch/axios';
import { saveMessagesForTopic } from '../MessageHistory';
export const handleSendMessage = async ({
  newMessage,
  activeTab,
  tabs,
  setTabs,
  setNewMessage,
  setLoading,
  setError,
  truncateTopic,
}: HandleSendMessageProps) => {
  const getOptionId = parseInt(localStorage.getItem('currentOptionId') || '0');
  if (!newMessage.trim()) {
    setError('Please enter a message');
    return;
  }
  const activeTabData = tabs.find(tab => tab.id === activeTab);
  if (!activeTabData) return;
  const lastMessageId = activeTabData.messages.at(-1)?.id || 0;
  const message: Message = {
    id: lastMessageId + 1,
    text: newMessage,
    isCurrentUser: true,
    timestamp: new Date(),
    optionId: getOptionId,
  };
  const updatedMessages = [...activeTabData.messages, message];
  const updatedTabs = tabs.map(tab =>
    tab.id === activeTab
      ? {
        ...tab,
        topic: activeTabData.messages.length === 0 ? truncateTopic(newMessage, 20) : tab.topic,
        messages: updatedMessages,
      }
      : tab,
  );
  setTabs(updatedTabs);
  setNewMessage('');
  setLoading(true);
  try {
    const answer = await textChat(getOptionId, { message: updatedMessages[updatedMessages.length - 1].text });
    const botMessage: Message = {
      id: updatedMessages.length + 1,
      text: answer,
      isCurrentUser: false,
      timestamp: new Date(),
    };
    setTabs(updatedTabs.map(tab =>
      tab.id === activeTab
        ? { ...tab, messages: [...tab.messages, botMessage] }
        : tab,
    ));
    saveMessagesForTopic(activeTabData.topic, [...updatedMessages, botMessage]);
  } catch (error) {
    setError('Failed to send message. Please try again.');
  } finally {
    setLoading(false);
  }
};
